import * as Html from "../../util/Html.ts";
export {initDom}
Html.registerWidget('widget/form/onoff-checkbox',{initDom:initDom})

function initDom(elem: HTMLElement){
  const input = elem.querySelector('input') as HTMLInputElement;
  if(!input) return;

  elem.addEventListener('click', function(){
    if(!input.disabled){
      input.checked = !input.checked;
      input.dispatchEvent(new Event('change'));
    }
  });

  function updateClasses(){
    elem.classList.toggle('fw-onoff-disabled', input.disabled);
    elem.classList.toggle('fw-onoff-on', input.checked);
  }

  input.addEventListener('change', updateClasses);
  input.addEventListener('ui-change', updateClasses);
}